<!-- Card -->
<script lang="ts" setup>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { CssFramework, DisplayStyle } from '../Enums/UiEnums';
import { bootstrapBackgroundColor } from '../lib/StyleHelpers';
import { assertInternally } from '../lib/Environment';
import "../../css/choice.css"

    const props = withDefaults(defineProps<{
            showDetails?: boolean,
            headerTitle?: string,
            headerStyle?: "normal" | "medium",
            headerDisplayStyle?: DisplayStyle,
            cssFramework?: CssFramework
        }>(), {
            showDetails: true,
            headerStyle: "normal",
            headerDisplayStyle: DisplayStyle.Primary,
            cssFramework: CssFramework.Bootstrap
        });

    const headerDiv = ref<HTMLElement>();

    const headerStyle = computed<string|undefined>(() =>{
            switch (props.headerStyle)
            {
                case "medium":
                    return "font-size:1.25rem";
            }
        });

    const headerClass = computed(() =>{
        if (CssFramework.EverHealth === props.cssFramework)
        {
            switch(props.headerDisplayStyle)
            {
                case DisplayStyle.Primary:
                    return "card-header everhealth-header-primary";
            }
        }

        if (CssFramework.Bootstrap != (props.cssFramework ?? CssFramework.Bootstrap))
        {
            assertInternally(`Unhandled framework: ${props.cssFramework}`);
        }

        // Resort to Bootstrap 
        return "card-header " + bootstrapBackgroundColor(props.headerDisplayStyle ?? DisplayStyle.Primary)
    });

    const titleClass = computed(() => {
        if (props.cssFramework === CssFramework.EverHealth)
        {
            switch(props.headerDisplayStyle)
            {
                case DisplayStyle.Primary:
                    return "everhealth-header-primary-title"
            }
        }
    });
</script>

<style scoped>
    .card-padding {
        padding: 1rem;
    }

    .everhealth-header-primary {
        border-top: 4px solid #146AFF
    }
    .everhealth-header-primary-title {
        color: var(--everhealth-primary-color, purple);
        font-weight: bold;
    }
</style>

<template>
    <div class="card SectionPadding" v-cloak>
        <div 
            ref="headerDiv"
            :class="headerClass"
            :title="headerTitle"
            :style="headerStyle">

            <span :class="titleClass">
                <slot name="title">
                    <span style="color:red">Need slot data: title</span>
                </slot>
            </span>
        </div>
        <div class="card-body card-padding card-border" v-if="props.showDetails ?? true">
            <slot>
            </slot>
        </div>
    </div>    
</template>
